<template>
  <div
    :class="{ [`FancyHeading--${mode}`]:true, 'flex items-center flex-wrap': horizontal, uppercase, 'mb-4': spaced }"
    class="FancyHeading font-extrabold font-stylized"
  >
    <div
      :class="{'mr-3': horizontal}"
      class="FancyHeading-title text-4xl"
    >
      {{ title }}
    </div>
    <div
      :class="{'-mt-3': !horizontal, 'text-4xl': horizontal}"
      class="FancyHeading-subtitle text-2xl"
    >
      {{ subtitle }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: '',
      validation: (value) => ['light', 'dark'].includes(value)
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    uppercase: {
      type: Boolean,
      default: true
    },
    spaced: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style rel='stylesheet/scss' lang='scss'>
@import '~utils';

.FancyHeading {
  &-title {
    color: map_get($textColors, grey)
  }

  &-subtitle {
    color: map_get($textColors, black)
  }

  &--dark {
    .FancyHeading-title {
      color: map_get($textColors, grey-darkest)
    }

    .FancyHeading-subtitle {
      color: map_get($textColors, grey)
    }
  }

  &--light {
    .FancyHeading-title {
      color: map_get($textColors, white)
    }

    .FancyHeading-subtitle {
      color: map_get($textColors, grey)
    }
  }
}
</style>
